//RUTAS UBICACIONES
//--gam ubicaciones
export const urlGetPlaces = "/api/locations/places";
export const urlCreatePlaces = "/api/locations/places";
export const urlEditPlaces = "/api/locations/places";
//--provincias
export const urlGetProvincias = "/api/locations/provincias";
//--localidades
export const urlGetLocalidades = "/api/locations/localidades";
